
import { HttpProvider } from "../http/http.provider";
import { IAppConfig } from "../http/types/IApplicationConfig";

import { ServiceEndpointConstants } from "../ServiceUtil";
import { Observable } from "rxjs";
import { share, map } from "rxjs/operators";
import { IHttpRequestConfig } from "../http";
import { IDemand, IDemandResponse } from "./demand.interface";
import { IDemandRole } from "../DemandRoleService";

export class DemandDelegate
{
    constructor(private SERVICE_CONFIG: IAppConfig, private http: HttpProvider)
    {
    }

    public getAllDemands(): Observable<IDemandResponse>
    {
        const config: IHttpRequestConfig = {
            params: {
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.DEMAND.GET, null, config).pipe(
            map((response: any) =>
            {
                return {
                    demands: DemandDelegate.normalizeDemands(response.data.demands || []),
                    success: response.data.success
                };
            }),
            share());
    }

    public createNewDemand(newDemand: IDemand): Observable<IDemandResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.DEMAND.CREATE, newDemand).pipe(
            map((response: any) =>
            {
                return {
                    demands: DemandDelegate.normalizeDemands(response.data.demands || []),
                    success: response.data.success,
                    demandId: response.data.demandId
                };
            }),
            share());
    }

    public updateDemand(demand: IDemand): Observable<IDemandResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.DEMAND.UPDATE, demand).pipe(
            map((response: any) =>
            {
                return {
                    demands: DemandDelegate.normalizeDemands(response.data.demands || []),
                    success: response.data.success,
                    demandId: demand.demandId
                };
            }),
            share());
    }

    public createNewDemandRole(newDemandRole: IDemandRole): Observable<IDemandResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.DEMAND.CREATE_ROLE, newDemandRole).pipe(
            map((response: any) =>
            {
                return {
                    demands: DemandDelegate.normalizeDemands(response.data.demands || []),
                    success: response.data.success,
                    demandId: response.data.demandId,
                    demandRoleId: response.data.demandRoleId
                };
            }),
            share());
    }

    public updateDemandRole(demandRole: IDemandRole): Observable<IDemandResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.DEMAND.UPDATE_ROLE, demandRole).pipe(
            map((response: any) =>
            {
                return {
                    demands: DemandDelegate.normalizeDemands(response.data.demands || []),
                    success: response.data.success,
                    demandId: demandRole.demandId,
                    demandRoleId: demandRole.roleId

                };
            }),
            share());
    }

    public static normalizeDemands(demands: any): IDemand[]
    {
        return demands.map(demand =>
        {
            demand.accountManagerName = demand.accountManager ? demand.accountManager.managerName : "";
            delete demand.accountManager;

            return demand;
        });
    }
}